import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import Column from 'Shared/components/PagedView/Column';
import {withStringFilterProperties} from 'Shared/components/PagedView/Filter';
import {withValueChangedHook} from 'Shared/utilities/withValueChanged';
import './Clients.sass';
import {searchClients, changeClientsFilters} from 'GenericTexting/ducks/client';
import ModularHost from 'Shared/components/ModularHost/ModularHost';
import ToolbarHeader from 'Shared/components/Toolbar/ToolbarHeader';
import PagedView from 'Shared/components/PagedView/PagedView';

const Clients = () => {
  const dispatch = useDispatch();
  const {filter, clientPage} = useSelector((state: ReducerState) => state.clients);

  const changeFilter = withValueChangedHook(filter, changeClientsFilters, dispatch);
  const filterProperties = {
    changeFilter,
    filterData: filter,
  };

  useEffect(() => {
    dispatch(searchClients(undefined, filter));
  }, [dispatch, filter]);

  return (
    <ModularHost>
      <ToolbarHeader title="Clients" />
      <PagedView pagedViewKey="clients" loadMore={page => dispatch(searchClients(page, filter))} data={clientPage}>
        {columnProps => (
          <>
            <Column
              {...columnProps}
              title="Client Id"
              filterProperties={withStringFilterProperties(filterProperties, 'identifier')}
            >
              {client => client.identifier}
            </Column>
            <Column
              {...columnProps}
              title="Client Name"
              filterProperties={withStringFilterProperties(filterProperties, 'clientName')}
              default
            >
              {client => client.clientName}
            </Column>
          </>
        )}
      </PagedView>
    </ModularHost>
  );
};

export default Clients;
